import { connect } from 'react-redux';
import { IState } from '../../store';

import { IOfferCardServicePlaceUnderMapProps, OfferCardServicePlaceUnderMap } from './index';

export function mapStateToProps(state: IState): IOfferCardServicePlaceUnderMapProps {
  return {
    markup: state.widgetsMarkup.underMapMarkup,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OfferCardServicePlaceUnderMapContainer = connect<IOfferCardServicePlaceUnderMapProps>(mapStateToProps)(
  OfferCardServicePlaceUnderMap,
);
